// API Routes Constants
export const API_ROUTES = {
  // Product Categories
  PRODUCT_CATEGORIES: {
    CREATE: '/product-categories/create',
    UPDATE: '/product-categories/update',
    GET: '/product-categories',
    GET_ALL: '/product-categories/editor/categories',
    GET_ALL_PARENT: '/product-categories/editor/parent-categories',
    DELETE: '/product-categories/delete',
    GET_ALL_CATEGORIES: '/product-categories/all/categories',
    GET_ALL_LEVET01_CATEGORIES: '/product-categories/get-category/level/0-1',
  },

  // Product Brands
  PRODUCT_BRANDS: {
    CREATE: '/product-brands/create',
    UPDATE: '/product-brands',
    GET: '/product-brands',
    DELETE: '/product-brands',
    GET_ALL: '/product-brands/editor/all'
  },

  // Media
  MEDIA: {
    UPLOAD: '/media/upload',
    GET: '/media',
    GETDATE: '/media/dates',
    UPDATE: '/media/update',
    DELETE: '/media/delete',
  },

  // Customers
  CUSTOMERS: {
    CREATE: '/admin/customers/create',
    UPDATE: '/admin/customers/update',
    GET: '/admin/customers',
    GET_ALL: '/admin/customers/all',
    DELETE: '/admin/customers/delete',
  },

  // Pages
  PAGES: {
    CREATE: '/pages/create',
    UPDATE: '/pages/update',
    GET: '/pages/all',
    GET_SINGLE_PAGE: '/pages/find',
    DELETE: '/pages/delete',
  },
  
  // Products
  PRODUCTS: {
    CREATE: '/products/create',
    UPDATE: '/products/update',
    GET: '/products',
    GET_ALL_WITH_TAX: '/products/all/with-tax',
    GET_ALL_WITH_DETAILS: '/products/all/with-details',
    GET_SINGLE_PRODUCT: '/products',
    DELETE: '/products/delete',
    GET_CATEGORY_BRAND: '/products/categories-brands',
    GET_ALL: '/products/editor/all',
    GET_ALL_WITHOUT_PAGINATION: '/products/all/products-without-pagination',
  },

  // Menus
  MENUS: {
    CREATE: '/menus/create',
    UPDATE: '/menus/update',
    GET: '/menus/all',
    GET_SINGLE_MENU: '/menus/find',
    DELETE: '/menus/delete',
    ITEM_LIST: '/menus/item-list'
  },

  // Orders
  ORDERS: {
    CREATE: '/orders/create',
    UPDATE: '/orders/update',
    DELIVERY_VERIFICATION: '/orders/delivery-verification',
    GET: '/orders',
    GET_SINGLE_ORDER: '/orders',
    DELETE: '/orders/delete',
    CUSTOMER_NOTIFY: '/orders/customer-notify',
    CUSTOMER_NOTIFY_TO_EMAIL: '/orders/customer-notify/email',
    CUSTOMER_NOTIFY_TO_WHATSAPP: '/orders/customer-notify/whatsapp',
    GET_PLACEORDER_COUNT: '/orders/status/count',
    GET_SALEPLACEORDER_COUNT: '/orders/sale-person/status/count'
  },

  // Coupons
  COUPONS: {
    CREATE: '/coupons/create',
    UPDATE: '/coupons/update',
    GET: '/coupons',
    GET_SINGLE_COUPON: '/coupons',
    DELETE: '/coupons/delete',
  },

  // Banner
  BANNERS: {
    CREATE: '/banners/create',
    UPDATE: '/banners/update',
    GET: '/banners/all',
    GET_SINGLE_BANNER: '/banners/find',
    GET_ALL_BANNER: '/banners/allBanner',
    DELETE: '/banners/delete',
  },
  // Auth
  AUTH: {
    LOGIN: '/admin-users/login',
  },

  //Admin User
  ADMIN: {
    CREATE: '/admin-users/create',
    UPDATE: '/admin-users',
    GET: '/admin-users',
    GET_ALL: '/admin-users/',
    GET_ALL_SALES_PERSON: '/admin-users/sale-persons',
    DELETE: '/admin-users/'
  },

  // Options
  OPTIONS: {
    UPDATE: '/options/update',
    GET: '/options',
  },
  
  // Review
  REVIEW: {
    CREATE: '/reviews/create',
    UPDATE: '/reviews/update',
    GET: '/reviews',
    GET_SINGLE_REVIEW: '/reviews',
    DELETE: '/reviews',
    TOP_RATED: '/reviews/top-rated'
  },

  // Team
  TEAM: {
    CREATE: '/teams',
    GET_ALL: '/teams',
    GET_SINGLE: '/teams',
    UPDATE: '/teams',
    DELETE: '/teams',
  },

   // Role
   ROLE: {
     CREATE: '/roles',
     GET_ALL: '/roles/all',
     GET_SINGLE: '/roles',
     UPDATE: '/roles',
     DELETE: '/roles/delete',
   },

   // Blogs
   BLOGS: {
     CREATE: '/blogs/create',
     UPDATE: '/blogs/update',
     GET: '/blogs/all',
     GET_SINGLE_BLOG: '/blogs',
     DELETE: '/blogs/delete',
   },

    // Blog Categories
    BLOG_CATEGORIES: {
      CREATE: '/blog-categories/create',
      UPDATE: '/blog-categories/update',
      GET: '/blog-categories',
      GET_ALL: '/blogs/all/categories',
      GET_SINGLE: '/blog-categories/find',
      DELETE: '/blog-categories/delete',
    },

    // Subscribers
    SUBSCRIBERS: {
      CREATE: '/subscribers/create',
      UPDATE: '/subscribers/update',
      GET: '/subscribers',
      GET_ALL: '/subscribers/all',
      GET_ALL_WITHOUT_PAGINATION: '/subscribers/all/without-pagination',
      DELETE: '/subscribers/delete',
    },
  };